$('body').on('click', '.add-coupon-trigger', function() {
    openModal('.add-coupon');
    return false;
});

$("body").on("click", ".open-coupon-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".coupon-menu-wrapper");

    $(".coupon-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".coupon-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".coupon-menu-wrapper").attr("data-dropdown"));
    return false;
});

$('body').on('click', '.edit-coupon-trigger', function() {
    var data = $(this).parents('.coupon');
    var action = $('.edit-coupon form').attr('data-action').replace('{coupon}', data.attr('data-coupon'));
    $('.edit-coupon form').attr('action', action);

    $('.edit-coupon [name="coupon_code"]').val(data.attr('data-coupon_code'));
    $('.edit-coupon [name="max_seats"]').val(data.attr('data-max_seats'));
    $('.edit-coupon [name="seat_discount"]').val(data.attr('data-seat_discount'));
    $('.edit-coupon [name="notes"]').val(data.attr('data-notes'));
    $('.edit-coupon input[name="active"]').prop('checked', data.attr('data-active') === 'true' ? true : false);

    openModal('.edit-coupon');
    closeDropdown();
    return false;
});

$('body').on('submit', '.add-coupon form, .edit-coupon form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-coupon', function(data) {
    // console.log(data);
    var element;

    if($('.coupon[data-coupon="'+data.coupon+'"]').length) {
        element = $('.coupon[data-coupon="'+data.coupon+'"]');

        element.attr('data-year', data.year);
        element.attr('data-admin', data.admin);
        element.attr('data-owner', data.owner);
        element.attr('data-coupon_code', data.coupon_code);
        element.attr('data-max_seats', data.max_seats);
        element.attr('data-seat_discount', data.seat_discount);
        element.attr('data-notes', data.notes);
        element.attr('data-used', data.used);

        element.find('[data-input="owner_name"]').html(data.owner_name);
        element.find('[data-input="owner_hebrew_name"]').html(data.owner_hebrew_name);
        element.find('[data-input="coupon_code"]').html(data.coupon_code);
        element.find('[data-input="max_seats"]').html(data.max_seats);
        element.find('[data-input="seat_discount_parsed"]').html(data.seat_discount_parsed);
        element.find('[data-input="admin_full_name"]').html(data.admin_full_name);
        element.find('[data-input="notes"]').html(data.notes);
        element.find('[data-input="status"]').html(data.status);
        element.find('[data-input="status"]').attr('data-color', data.status_color);

        element.find('.coupon-menu').html(buttons(data.buttons));
        return;
    }

    if($('body').attr('data-page') === '1') {
        element = $('<tr>', {
            class: 'coupon',
            'data-coupon': data.coupon,
            'data-year': data.year,
            'data-admin': data.admin,
            'data-owner': data.owner,
            'data-coupon_code': data.coupon_code,
            'data-max_seats': data.max_seats,
            'data-seat_discount': data.seat_discount,
            'data-notes': data.notes,
            'data-used': data.used
        });

        element.append(`<td>
            <p data-input="owner_name">${data.owner_name}</p>
            <p data-input="owner_hebrew_name" ${data.owner_hebrew_name}</p>
        </td>

        <td data-input="coupon_code">${data.coupon_code}</td>

        <td>
            (<span data-input="max_seats">${data.max_seats}</span>)
            <span data-input="seat_discount_parsed">${data.seat_discount_parsed}</span>
        </td>

        <td data-input="admin_full_name">${data.admin_full_name}</td>

        <td>
            <p class="small-text" data-input="notes">${data.notes}</p>
        </td>

        <td><span class="highlight" data-color="${data.status_color}" data-input="status">${data.status}</span></td>
        <td><span class="highlight" data-color="${data.status_color}" data-input="status">${data.status}</span></td>
        <td class="coupon-menu-wrapper menu-wrapper" data-dropdown="coupon-${data.coupon}">
            <a href="" class="icon-more open-coupon-menu open-menu"></a>
            <ul class="coupon-menu menu">
                 ${buttons(data.buttons)}
            </ul>
        </td>`);

        $('.coupons tbody').prepend(element);
    }
});